import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { useSetScroll } from "~franchise-website/states";
import WebbeeLogo from "~franchise-website/svg/logos/Webbee";

const Topbar = () => {
	const setScroll = useSetScroll();

	return (
		<Box
			padding={1}
			display="flex"
			justifyContent="space-between"
			alignItems="center"
			width="100%">
			<Box
				display="flex"
				alignItems="center">
				<Box
					display="flex"
					alignItems="baseline"
					component="a"
					href="/"
					title="Mango Franchise"
					height={56}
					sx={{ width: { xs: "150px", md: "200px" } }}>
					<WebbeeLogo />
				</Box>
			</Box>
			<Box
				display="flex"
				alignItems="center">
				<Box
					sx={{ display: { md: "flex" } }}
					alignItems="center">
					<Box>
						<Button
							variant="contained"
							color="primary"
							component="a"
							target="blank"
							onClick={() => setScroll(true)}
							size="large">
							Request pricing
						</Button>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default Topbar;
